import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ActiveCartService, AuthService, SemanticPathService } from 'haba-core';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { Urls } from 'src/app/@enums/urls';

@Injectable({
  providedIn: 'root',
})
export class HabaCheckoutGuard {
  constructor(
    protected router: Router,
    protected authService: AuthService,
    protected activeCartService: ActiveCartService,
    protected semanticPathService: SemanticPathService,
    @Inject(PLATFORM_ID) protected platform_id
  ) {}

  // This guard is needed if a customer goes directly on /checkout -> redirect to /cart
  canActivate(): Observable<true | UrlTree> {
    if (isPlatformBrowser(this.platform_id)) {
      this.authService
        .isUserLoggedIn()
        .pipe(
          switchMap((isLoggedIn) => {
            if (isLoggedIn) {
              return combineLatest([
                this.activeCartService.getEntries(),
                this.activeCartService.isStable(),
              ]).pipe(filter(([, isStable]) => isStable));
            } else {
              this.router.navigate([this.semanticPathService.get(Urls.CART)], { replaceUrl: true });
              return of(null);
            }
          })
        )
        .subscribe(([entries]) => {
          if (entries === null) return;

          if (this.router.url.includes('/checkout/billing-address')) {
            this.router.navigate(['/checkout/shipping-address'], { replaceUrl: true });
          }

          if (this.router.url.includes('/checkout/shipping-address')) {
            this.router.navigate(['/checkout/payment-details'], { replaceUrl: true });
          }

          if (this.router.url.includes('/checkout/payment-details')) {
            this.router.navigate(['/checkout/review-order'], { replaceUrl: true });
          }
        });

      return of(true);
      // CSR
    } else {
      // SSR
      return of(true);
    }
  }
}
